import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CInput,
  CInputGroup,
  CInputGroupAppend,
  CNav,
  CNavItem,
  CNavLink
} from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import LiterarteActivities from "../../../components/LiterartePageContent/Activities";
import LiterarteMine from "../../../components/LiterartePageContent/MineProductions";
import ProtectedRoute from "../../../components/ProtectedRoute";

class Literarte extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: "mine",
      inputSearch: ""
    };
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
  }

  render() {
    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        <CCard>
          <CCardBody>
            <h3 className="m-0 d-flex align-items-center">
              <i
                className="fa fa-quote-right mr-3"
                style={{ color: "var(--purple)" }}
              ></i>
              Literarte
            </h3>
          </CCardBody>
          <CCardFooter className="p-0 overflow-hidden">
            <div className="d-flex w-100">
              <div style={{ display: "flex", flex: 1 }}>
                <CNav
                  variant="tabs"
                  className="nav-underline nav-underline-purple flex-nowrap"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <CNavItem>
                    <CNavLink
                      className="p-3"
                      active={this.state.page === "mine"}
                      onClick={() => this.setState({ page: "mine" })}
                    >
                      Minhas produções
                    </CNavLink>
                  </CNavItem>
                  <CNavItem>
                    <CNavLink
                      className="p-3"
                      active={this.state.page === "activities"}
                      onClick={() => this.setState({ page: "activities" })}
                    >
                      Atividades
                    </CNavLink>
                  </CNavItem>
                </CNav>
              </div>
              <div
                style={{
                  width: "240px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: "1.25rem"
                }}
                className="py-2 d-none d-sm-flex"
              >
                <CInputGroup
                  className="d-flex justify-content-end"
                  style={{ flexWrap: "nowrap" }}
                >
                  <CInput
                    className="form-control"
                    type="text"
                    style={{ width: "auto", height: "auto" }}
                    placeholder="Pesquisar"
                    onChange={e =>
                      this.setState({ inputSearch: e.target.value })
                    }
                  ></CInput>
                  <CInputGroupAppend>
                    <CButton
                      color="light"
                      style={{ border: "1px solid #d8dbe0" }}
                      onClick={() =>
                        this.setState(state => ({
                          // search: state.inputSearch
                        }))
                      }
                    >
                      <i className="fa fa-search text-muted m-0"></i>
                    </CButton>
                  </CInputGroupAppend>
                </CInputGroup>
              </div>
            </div>
          </CCardFooter>
        </CCard>
        {this.state.page === "mine" ? (
          <LiterarteMine search={this.state.inputSearch} />
        ) : this.state.page === "activities" ? (
          <LiterarteActivities search={this.state.inputSearch} />
        ) : (
          <>Nada a ser exibido</>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

Literarte.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

Literarte.defaultProps = {
  hideLayout: false,
  guestLogin: false
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Literarte);
